import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = 'https://broadcastbackend.onrender.com/api';

export default function AdminPanel({ onBack }) {
  const [activeTab, setActiveTab] = useState('access');
  const [submissions, setSubmissions] = useState([]);
  const [stats, setStats] = useState({ accessRequests: 0, contactForms: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const [submissionsRes, statsRes] = await Promise.all([
        axios.get(`${API_URL}/submissions`),
        axios.get(`${API_URL}/stats`)
      ]);

      setSubmissions(submissionsRes.data);
      setStats(statsRes.data);
      setError('');
    } catch (err) {
      setError('Failed to load data. Make sure backend is running on https://broadcastbackend.onrender.com');
    } finally {
      setLoading(false);
    }
  };

  const deleteEntry = async (id) => {
    if (!window.confirm('Are you sure you want to delete this entry?')) return;

    try {
      await axios.delete(`${API_URL}/submissions/${id}`);
      loadData();
    } catch (err) {
      setError('Failed to delete entry');
    }
  };

  const exportJSON = () => {
    const json = JSON.stringify(submissions, null, 2);
    const blob = new Blob([json], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `tempes-submissions-${new Date().toISOString().slice(0, 10)}.json`;
    a.click();
  };

  const filteredSubmissions = activeTab === 'access'
    ? submissions.filter(s => s.type === 'access_request')
    : submissions.filter(s => s.type === 'contact_form');

  return (
    <div className="admin-panel">
      <div className="admin-container">
        <div className="admin-header">
          <div>
            <h1>🔐 Tempes Admin Panel</h1>
            <p>Manage form submissions</p>
          </div>
          <div className="admin-header-stats">
            <div className="stat">
              <div className="stat-number">{stats.accessRequests}</div>
              <div className="stat-label">Access Requests</div>
            </div>
            <div className="stat">
              <div className="stat-number">{stats.contactForms}</div>
              <div className="stat-label">Contact Forms</div>
            </div>
          </div>
          <button className="back-btn" onClick={onBack}>🚪 Logout</button>
        </div>

        <div className="admin-content">
          {error && <div className="error-banner">{error}</div>}

          <div className="admin-actions">
            <button className="btn-export" onClick={exportJSON}>📥 Export JSON</button>
            <button className="btn-refresh" onClick={loadData}>🔄 Refresh</button>
          </div>

          <div className="admin-tabs">
            <button
              className={`tab-btn ${activeTab === 'access' ? 'active' : ''}`}
              onClick={() => setActiveTab('access')}
            >
              Access Requests
            </button>
            <button
              className={`tab-btn ${activeTab === 'contact' ? 'active' : ''}`}
              onClick={() => setActiveTab('contact')}
            >
              Contact Messages
            </button>
          </div>

          {loading ? (
            <div className="loading">Loading submissions...</div>
          ) : filteredSubmissions.length === 0 ? (
            <div className="empty-state">
              <h2>No submissions yet</h2>
              <p>Submissions will appear here</p>
            </div>
          ) : (
            <div className="table-wrapper">
              <table>
                <thead>
                  <tr>
                    {activeTab === 'access' ? (
                      <>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Country</th>
                        <th>Date</th>
                        <th>Action</th>
                      </>
                    ) : (
                      <>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Subject</th>
                        <th>Date</th>
                        <th>Action</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {filteredSubmissions.map((item) => (
                    <tr key={item._id}>
                      <td>{item.name || 'N/A'}</td>
                      <td>{item.email || 'N/A'}</td>
                      {activeTab === 'access' ? (
                        <>
                          <td>{item.phone || 'N/A'}</td>
                          <td>{item.country || 'N/A'}</td>
                        </>
                      ) : (
                        <td>{item.subject || 'N/A'}</td>
                      )}
                      <td className="timestamp">
                        {new Date(item.createdAt).toLocaleString()}
                      </td>
                      <td>
                        <button
                          className="btn-delete"
                          onClick={() => deleteEntry(item._id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
